import { ROUTES } from '@constants'

export const getTitleTabs = (appTitle: string): Record<string, string> => ({
  '/windows': appTitle ? `Windows - ${appTitle}` : 'Windows',
  '/diagrams': appTitle ? `Diagrams - ${appTitle}` : 'Diagrams',
  '/tooltips': appTitle ? `Tooltips - ${appTitle}` : 'Tooltips',
  '/style_settings': appTitle ? `Style Settings - ${appTitle}` : 'Style Settings',
  '/search_assistants': appTitle ? `Search Assistants - ${appTitle}` : 'Search Assistants',
  '/variables': appTitle ? `Variables - ${appTitle}` : 'Variables',
  '/dropdown_entities': appTitle ? `Dropdown Entities - ${appTitle}` : 'Dropdown Entities',
  '/list_controls': appTitle ? `List Controls - ${appTitle}` : 'List Controls',
  '/gantt': appTitle ? `Gantt-Chart - ${appTitle}` : 'Gantt-Chart',
  '/dictionary': appTitle ? `Dictionary - ${appTitle}` : 'Dictionary',
  '/menu_setting': appTitle ? `Menu Setting - ${appTitle}` : 'Menu Setting',
  '/login': appTitle ? `Login - ${appTitle}` : 'Login',
  '/search_assistant': appTitle ? `Search Assistant - ${appTitle}` : 'Search Assistant',
  '/search': appTitle ? `Search - ${appTitle}` : 'Search',
  '/parameters': appTitle ? `Parameters - ${appTitle}` : 'Parameters',
  '/display_rules': appTitle ? `Display Rules - ${appTitle}` : 'Display Rules',
  '/bar_chart': appTitle ? `Bar Chart - ${appTitle}` : 'Bar Chart',
  '/timelines': appTitle ? `TimeLines - ${appTitle}` : 'TimeLines',
  '/choose_context': appTitle ? `Choose Context - ${appTitle}` : 'Choose Context',
  '/contexts': appTitle ? `Contexts - ${appTitle}` : 'Contexts',
  '/views': appTitle ? `Views - ${appTitle}` : 'Views',
  '/forms': appTitle ? `Forms - ${appTitle}` : 'Forms',
  '/context_menu': appTitle ? `Context Menu - ${appTitle}` : 'Context Menu',
  '/control_panels': appTitle ? `Control Panels - ${appTitle}` : 'Control Panels',
})

export const ARRAY_SUPPORTED_EDIT_PAGES = [
  ROUTES.CONFIG_VIEWS_EDIT,
  ROUTES.CONFIG_FORMS_EDIT,
  ROUTES.CONFIG_DROP_DOWN_ENTITY_EDIT,
  ROUTES.CONFIG_LIST_CONTROLS_EDIT,
]
